import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { TFileWithType } from '@treezor/design-system';

import { ICreateUserInfo } from '@/features/user/contexts/CreateUserContext';
import { Section } from '@/features/user/components/CreateUser/layout/ContentLayout';
import { useCreateBusinessUser } from '@/features/user/hooks/createUser/useCreateBusinessUser';
import { CreateUserKycDocuments } from '@/features/user/components/CreateUser/CreateUserKycDocuments';

interface IDocumentsProps {
  memberIndex: number;
  memberWatch: ICreateUserInfo;
  handleChange: (memberIndex: number, key: keyof ICreateUserInfo, value: string | TFileWithType[]) => void;
}

export function CompanyMembersDocuments({
  memberIndex,
  memberWatch,
  handleChange: handleChangeMember,
}: IDocumentsProps) {
  const { t } = useTranslation();
  const { user } = useCreateBusinessUser();

  const handleChange = useCallback(
    (field: keyof ICreateUserInfo, value: string | TFileWithType[]) => {
      handleChangeMember(memberIndex, field, value);
    },
    [handleChangeMember, memberIndex],
  );

  return (
    <Section title={t('pages.dashboard.createUser.form.blocks.documents')} key={`document-${memberIndex}`}>
      <CreateUserKycDocuments
        handleFileChange={(files: TFileWithType[]) => handleChange('kycDocuments', files)}
        defaultFiles={user?.members?.[memberIndex]?.kycDocuments ?? memberWatch?.kycDocuments}
      />
    </Section>
  );
}
